import { render, staticRenderFns } from "./management-page.vue?vue&type=template&id=727d7b3e&scoped=true&"
import script from "./management-page.vue?vue&type=script&lang=js&"
export * from "./management-page.vue?vue&type=script&lang=js&"
import style0 from "./management-page.vue?vue&type=style&index=0&id=727d7b3e&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727d7b3e",
  null
  
)

export default component.exports